<template>
  <div class="pr5">
  <w-flex wrap class="mx-5">
    <div class="xs12 headline text-left pl7 pa1">Group by Label</div>
    <w-divider class="my6 mx-3"></w-divider>
  </w-flex>
  <LabelsScroll class="xs10"
    @setlabel="
      (label) => {
        (groupStore.state.label = label), delayedSearch(label);
      }
    "
  ></LabelsScroll>
  <w-flex grid class="xs10">
    <w-input
      label="Label"
      v-model.trim="groupStore.state.label"
      :validators="[validators.required]"
      @keyup="delayedSearch($event.target.value)"
      inner-icon-right="mdi mdi-close"
      @click:inner-icon-right="clearInput()"
    >
    </w-input
  ></w-flex>
  <w-flex wrap>
    <div class="xs12 mt5 text-left p5">IMEIs' List</div>
    <w-divider class="my6 mx-3"></w-divider>
  </w-flex>
  <div grid class="xs10 imei-container">
    <InteractiveListComponent
      :disabled="!groupStore.state.label || groupStore.state.label == ''||groupStore.state.label.includes(',')"
      :list="imeis"
      :required="true"
      @removeFromList="setImeiToRemove"
      @addToList="addImei"
    />
    <w-overlay v-model="showOverlay" :persistent="persistent" :persistent-no-animation="persistentNoAnimation"
    :opacity="opacity" class="pa10">
    <w-card bg-color="overlays center ma3">
    <!--span class="top">
      <w-icon @click="showOverlay = false" class="icon-button right">
        mdi mdi-close</w-icon>
      </span-->
      <div class="py2 px3">
       Confirm to remove {{imeiToRemove}} from {{groupStore.state.label}}?
      </div>
      <div>
        <w-button class="mx2" bg-color="primary" lg dark @click="showOverlay = false, imeiToRemove=null">
          <w-icon class="mr2">mdi mdi-arrow-left</w-icon>
          CANCEL
        </w-button>
        <w-button class="mx2" bg-color="error" lg dark @click="removeImei(imeiToRemove), showOverlay = false">
          <w-icon class="mr2">wi-cross</w-icon>
          CONFIRM
        </w-button>
      </div>
    </w-card>
  </w-overlay>
  </div>
    </div>
  
</template>
<script>
import { ref, reactive } from "vue";
import { groupStore } from "../store/label-group";
import InteractiveListComponent from "../components/InteractiveListComponent.vue";
import LabelsScroll from "../components/LabelsScroll.vue";
export default {
  name: "CreateGroupView",
  components: { InteractiveListComponent, LabelsScroll },
  setup: () => {
    const showOverlay=ref(false);
    const imeiToRemove=ref(null);
    const label = ref("");
    const delayed = reactive({
      timer: 0,
      function: null,
      ms: 500,
    });
    function delay(...args) {
      delayed.timer = setTimeout(delayed.function.bind(...args), delayed.ms);
    }

    // function setImeiToRemove(value){
    //   imeiToRemove.value=value
    // }
    let imeis = ref(groupStore.getImeis());

    function setImeiToRemove(value){
      showOverlay.value=true;
      imeiToRemove.value=value;
    }
    function delayedSearch(target) {
      clearTimeout(delayed.timer);
      delayed.timer = 0;
      delayed.function = function () {
        searchLabel(target);
      };
      delayed.ms = 500;
      clearTimeout(delayed.timer);
      delay(target);
    }
    //update becouse store is not reactive in setup
    function searchLabel(value) {
      groupStore.getImeiByLabel(value).finally(() => {
        imeis.value = groupStore.getImeis();
        groupStore.updateAllLabels();
      });
    }

    function removeImei(item) {
      groupStore.removeImei(item).finally(() => {
        imeis.value = groupStore.getImeis();
        groupStore.updateAllLabels();
      });
    }
    function addImei(item) {
      groupStore.addImei(item).finally(() => {
        imeis.value = groupStore.getImeis();
        console.log("added", item, imeis.value);
        groupStore.updateAllLabels();
      });
    }
    function clearInput() {
      groupStore.clear();
      searchLabel("");
    }
    return {
      label,
      validators: {
        required: (value) => !!value || "This field is required",
        notNull: (value) =>
          (!!value  && value != ""&& !value.includes(",")) ||
          "invalid Field",
      },
      delayedSearch,
      removeImei,
      addImei,
      groupStore,
      imeis,
      clearInput,
      showOverlay,
      imeiToRemove,
      setImeiToRemove
    };
  },
};
</script>
<style scoped>
.overlays {
  background-color: aliceblue;
}
.imei-container {
  letter-spacing: -0.5px;
  font-family: 'Courier New', monospace;
}
</style>